import { isNil } from 'es-toolkit';

/** Maps tag/category fields to SavvyKit `Tag` chip visuals (emoji vs hex color vs smart Zap). */

/** Minimal fields needed to derive SavvyKit `Tag` indicator props (emoji wins over hex color; smart overrides both). */
export type TagIndicatorSource = {
  readonly emoji?: string | null;
  readonly hexColorCode?: string | null;
  readonly isSmart?: boolean | null;
};

type TagIndicatorPropsOptions = {
  /** When neither emoji nor hex is set, apply this color (e.g. default category swatch). */
  readonly hexColorFallback?: string;
};

/**
 * Props to spread onto `@savvy-kit/tag` — smart overrides emoji and color (renders a
 * Zap icon inheriting the category color); otherwise emoji takes precedence over `hexColorCode`,
 * matching `CategoryIndicator` behavior.
 */
export function tagIndicatorPropsFromTagData(tag: TagIndicatorSource, options?: TagIndicatorPropsOptions) {
  // Smart Tags always carry the Zap indicator — the kit will inherit the supplied
  // color (preset or hex). We pass color alongside so the Zap can tint itself.
  if (tag.isSmart === true) {
    const color = tag.hexColorCode ?? options?.hexColorFallback ?? undefined;
    return !isNil(color) ? { smart: true, color } : { smart: true };
  }
  if (!isNil(tag.emoji)) {
    return { emoji: tag.emoji };
  }
  if (!isNil(tag.hexColorCode)) {
    return { color: tag.hexColorCode };
  }
  if (!isNil(options?.hexColorFallback)) {
    return { color: options.hexColorFallback };
  }
  return {};
}
